import { api, API_DEPLOYED_URL } from "../config/api";

/**
 * Sends a secure, production-ready invitation with an expiring activation link.
 * All user data, permissions, rate-limiting, and tokens are handled server-side.
 */
export const sendInvitation = async (userId) => {
  if (!userId) {
    throw new Error("User ID is required to send an invitation");
  }

  // Uses REACT_APP_API_DEPLOYED_URL from .env or current browser origin
  const frontendUrl =
    API_DEPLOYED_URL ||
    process.env.REACT_APP_API_DEPLOYED_URL ||
    (typeof window !== "undefined" && window.location.origin) ||
    "http://localhost:3000";

  const response = await api.post(`/users/${userId}/send-invitation`, {
    frontendUrl,
  });
  return response.data;
};

/**
 * Legacy mail sender (preserved for backward compatibility).
 */
export const sendMail = async (toEmail, password, extraData = {}) => {
  try {
    const role = (extraData?.role || "").toLowerCase();
    const isAdmin = role.includes("admin") || role === "editor";

    const endpoint = isAdmin
      ? "/mail/send-admin-welcome"
      : "/mail/send-welcome-email";

    const payload = {
      email: toEmail,
      name: extraData?.name || "User",
      role: extraData?.role || (isAdmin ? "admin" : "user"),
      password:
        password ||
        "Please use 'Forgot Password' on the login screen to set your password",
      ...extraData,
    };

    // If no password is known, also trigger password reset email via Firebase Auth
    if (!password) {
      try {
        await api.post("/auth/forgot-password", { email: toEmail });
      } catch (forgotErr) {
        console.warn("Forgot password trigger warning:", forgotErr);
      }
    }

    const response = await api.post(endpoint, payload);
    return response.data;
  } catch (err) {
    console.error("Failed to send invitation email:", err);
    throw err;
  }
};


